module.exports = __webpack_public_path__ + "static/media/img20.5e857c4d.JPG";